import React from "react";
import { Redirect, Link } from "react-router-dom";
import { Alert, Button, Card, CardBody, FormGroup, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Col } from "reactstrap";

const OTP_COOLDOWN_SECONDS = 180;

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: localStorage.getItem('username') || "",
      otp: "",
      new_password: "",
      confirm_password: "",
      otpRequested: false,
      otpSubmitting: false,
      cooldownSeconds: 0,
      submitting: false,
      errorMessage: null,
      successMessage: null,
      validation: {},
      redirectToLogin: false,
    };
    this.cooldownInterval = null;
    this.redirectTimeout = null;
  }

  componentWillUnmount() {
    if (this.cooldownInterval) clearInterval(this.cooldownInterval);
    if (this.redirectTimeout) clearTimeout(this.redirectTimeout);
  }

  startCooldown() {
    if (this.cooldownInterval) clearInterval(this.cooldownInterval);
    this.setState({ cooldownSeconds: OTP_COOLDOWN_SECONDS });
    this.cooldownInterval = setInterval(() => {
      this.setState(prevState => {
        const next = prevState.cooldownSeconds - 1;
        if (next <= 0) {
          clearInterval(this.cooldownInterval);
          return { cooldownSeconds: 0 };
        }
        return { cooldownSeconds: next };
      });
    }, 1000);
  }

  handleInputChanged(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  }

  handleRequestOtp() {
    const { username, otpSubmitting, cooldownSeconds } = this.state;
    if (otpSubmitting || cooldownSeconds > 0) return;

    if (!username || username.trim().length === 0) {
      this.setState({ errorMessage: "Username tidak ditemukan, silakan login ulang." });
      return;
    }

    this.setState({ otpSubmitting: true, errorMessage: null, successMessage: null });

    fetch(process.env.REACT_APP_API_URL + '/user/password/otp', {
      method: 'POST',
      body: JSON.stringify({ username }),
    })
      .then(res => res.json())
      .then((data) => {
        if (!data || !data.header || data.header.status_code !== 200) {
          const msg = (data && data.header && data.header.error_message) || 'Gagal mengirim OTP. Coba lagi.';
          this.setState({ errorMessage: msg, otpSubmitting: false });
          // Backend already rejects a new request while a previous OTP is active,
          // so mirror that lock client-side too.
          this.startCooldown();
          return;
        }
        this.setState({
          otpRequested: true,
          otpSubmitting: false,
          errorMessage: null,
          successMessage: "Jika akun anda terdaftar, kode OTP telah dikirim ke email Anda.",
        });
        this.startCooldown();
      })
      .catch(() => {
        this.setState({ errorMessage: "Terjadi kesalahan jaringan. Coba lagi.", otpSubmitting: false });
      });
  }

  validate() {
    const { otp, new_password, confirm_password } = this.state;
    const errors = {};

    if (!otp || otp.trim().length === 0) {
      errors.otp = "Kode OTP wajib diisi.";
    } else if (!/^\d{6}$/.test(otp)) {
      errors.otp = "Kode OTP harus 6 digit angka.";
    }

    const strongPwRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    if (!new_password || new_password.length === 0) {
      errors.new_password = "Password baru wajib diisi.";
    } else if (!strongPwRegex.test(new_password)) {
      errors.new_password = "Password baru harus minimal 8 karakter dan mengandung huruf besar, huruf kecil, angka, dan simbol.";
    }

    if (!confirm_password || confirm_password.length === 0) {
      errors.confirm_password = "Konfirmasi password wajib diisi.";
    } else if (confirm_password !== new_password) {
      errors.confirm_password = "Konfirmasi password tidak sama dengan password baru.";
    }

    this.setState({ validation: errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit() {
    if (!this.validate()) {
      this.setState({ errorMessage: "Periksa kembali isian Anda.", successMessage: null });
      return;
    }

    const { username, otp, new_password } = this.state;
    this.setState({ submitting: true, errorMessage: null, successMessage: null });

    fetch(process.env.REACT_APP_API_URL + '/user/password/reset', {
      method: 'POST',
      body: JSON.stringify({ username, otp, new_password }),
    })
      .then(res => res.json())
      .then((data) => {
        if (!data || !data.header || data.header.status_code !== 200) {
          const msg = (data && data.header && data.header.error_message) || 'Gagal mengubah password. Coba lagi.';
          this.setState({ errorMessage: msg, submitting: false });
          return;
        }
        this.setState({
          successMessage: "Password berhasil diubah. Mengarahkan ke halaman login...",
          errorMessage: null,
          submitting: false,
        });
        this.redirectTimeout = setTimeout(() => {
          this.setState({ redirectToLogin: true });
        }, 1500);
      })
      .catch(() => {
        this.setState({ errorMessage: "Terjadi kesalahan jaringan. Coba lagi.", submitting: false });
      });
  }

  renderFieldError(name) {
    const { validation } = this.state;
    if (!validation || !validation[name]) return null;
    return (
      <div style={{ color: '#f5365c', fontSize: '0.8rem', marginTop: '0.25rem' }}>
        {validation[name]}
      </div>
    );
  }

  render() {
    if (this.state.redirectToLogin) {
      return <Redirect to="/auth/login" />;
    }

    const { cooldownSeconds, otpRequested, otpSubmitting } = this.state;
    const otpButtonDisabled = otpSubmitting || cooldownSeconds > 0;
    let otpButtonLabel = "Kirim OTP";
    if (otpSubmitting) {
      otpButtonLabel = "Mengirim...";
    } else if (cooldownSeconds > 0) {
      otpButtonLabel = `Kirim Ulang OTP (${cooldownSeconds}s)`;
    } else if (otpRequested) {
      otpButtonLabel = "Kirim Ulang OTP";
    }

    return (
      <>
        <Col lg="5" md="7">
          <Card className="bg-secondary shadow border-0">
            <CardBody className="px-lg-5 py-lg-5">
              <div className="text-center text-muted mb-4">
                <small>Lupa password? Minta OTP dan atur password baru</small>
              </div>
              {this.state.errorMessage && (
                <Alert color="danger">
                  {this.state.errorMessage}
                </Alert>
              )}
              {this.state.successMessage && (
                <Alert color="success">
                  {this.state.successMessage}
                </Alert>
              )}
              <Form role="form">
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-satisfied" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Username"
                      type="text"
                      name="username"
                      value={this.state.username}
                      readOnly
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup className="mb-3">
                  <Button
                    color="info"
                    type="button"
                    block
                    disabled={otpButtonDisabled}
                    onClick={() => this.handleRequestOtp()}
                  >
                    {otpButtonLabel}
                  </Button>
                </FormGroup>
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-key-25" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Kode OTP"
                      type="text"
                      name="otp"
                      maxLength={6}
                      value={this.state.otp}
                      onChange={this.handleInputChanged.bind(this)}
                    />
                  </InputGroup>
                  {this.renderFieldError('otp')}
                </FormGroup>
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Password Baru"
                      type="password"
                      name="new_password"
                      value={this.state.new_password}
                      onChange={this.handleInputChanged.bind(this)}
                    />
                  </InputGroup>
                  {this.renderFieldError('new_password')}
                </FormGroup>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Konfirmasi Password Baru"
                      type="password"
                      name="confirm_password"
                      value={this.state.confirm_password}
                      onChange={this.handleInputChanged.bind(this)}
                    />
                  </InputGroup>
                  {this.renderFieldError('confirm_password')}
                </FormGroup>
                <ul className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.25rem', paddingLeft: '1rem' }}>
                  <li>Minimal 8 karakter</li>
                  <li>Wajib mengandung huruf besar</li>
                  <li>Wajib mengandung huruf kecil</li>
                  <li>Wajib mengandung angka</li>
                  <li>Wajib mengandung simbol</li>
                </ul>
                <div className="text-center">
                  <Button
                    className="my-4"
                    color="primary"
                    type="button"
                    disabled={this.state.submitting}
                    onClick={() => this.handleSubmit()}
                  >
                    {this.state.submitting ? 'Menyimpan...' : 'Ubah Password'}
                  </Button>
                </div>
                <div className="text-center">
                  <Link to="/auth/login" className="text-muted">
                    <small>Kembali ke halaman login</small>
                  </Link>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </>
    );
  }
}

export default ForgotPassword;
